const Form047EN = {
    stepName: {
        importantNotes: "Important Notes",
        personalInfo: "Personal Info",
        workExperience: "Work Experience",
        confirmation: "Confirmation",
        // importantNotes: "Important Notes",
    },
    statementHeader: "Notes for completing the Form",
    statementContent:
        "The name, address and registration date of your child care centre and your name will be subject to inspection by the public in accordance with the provision stipulated in Section 8 of the Child Care Services Ordinance for the purpose of verifying that your child care centre is registered under the above Ordinance.",
    importantNotes: {
        importantNote:
            'Applicant without an "iAM Smart+" account is required to return the completed form to Joint Office for Kindergartens and Child Care Centres for processing (Address: Room 602, 6/F, 14 Taikoo Wan Road, Taikoo Shing, Hong Kong). Please ensure that sufficient postage is paid to avoid unsuccessful delivery. Any underpaid mail items will be disposed of by the Hongkong Post.',

        title: "Personal Information Collection Statement",
        p_title: "Purpose of Collection",
        p1_1: "The personal data provided by you in this form will be used by the EDB for one or more of the following purposes:",
        p1_a: "Activities relating to the processing, authentication and counter-checking of the application by Operator of Child Care Centre for centre registration; ",
        p1_b: "Activities relating to matching of the personal data with the database of other relevant Government bureaux / departments in connection with the processing, authentication and counter-checking of the application mentioned in (a) above;",
        p1_c: "Activities relating to matching of the personal data within the database of EDB for purposes of verifying / updating records of the EDB;",
        p1_d: "Activities relating to training and development including invitation of participation in programmes / activities, applications for reimbursement of course fees, assessment of nominations, awards and scholarship, and monitoring of attainment progress;",
        p1_e: "Activities relating to the processing and vetting of applications for, and disbursement of, funding / grants / subsidies, and conducting of audits; ",
        p1_f: "Activities relating to compilation of statistics, research and Government publications; and",
        p1_g: "Activities relating to the administration and enforcement of rules and regulations including the Education Ordinance (Cap. 279), its subsidiary legislation (such as the Education Regulations and the Grant/Subsidized Schools Provident Fund Rules), the Codes of Aid; and the Child Care Services Ordinance (Cap.243) and its subsidiary legislation ( i.e., the Child Care Services Regulations (Cap 243 A) )",

        p2: "The provision of personal data required by this form and during the processing of this form is obligatory.  In the event that you do not provide those personal data, we may not be able to handle or further process the application.",

        p_title3: "Classes of Transferees",
        p3_1: "The personal data you provide will be made available to persons working in EDB.  Apart from this, they may be transferred or disclosed to the parties or in the circumstances listed below:-",
        p3_a: "other Government bureau and departments, including Social Welfare Department, Town Planning Board, Lands Department, Fire Services Department, Buildings Department or Architectural Services Department, Electrical and Mechanical Services Department, and Student Finance Office, for the purposes mentioned in paragraph 1 above;",
        p3_b: "the school in which the form relates for the purposes mentioned in paragraph 1 above;",
        p3_c: "personnel, agent, service provider engaged by EDB to provide services or advice; and /or other relevant individuals/ organizations (such as property owner or Housing Authority), for purposes mentioned in paragraph 1 above;",
        p3_d: "where you have given your prescribed consent to such disclosure; and",
        p3_e: "where such disclosure is authorised or required under the law or court order applicable to Hong Kong and will be subject to inspection by the public in accordance with the provision stipulated in Section 8 of the Child Care Services Ordinance for the purpose of verifying that your child care centre is registered under the above Ordinance.",

        p_title4: "Access to Personal Data",
        p4: "You have the right to request access to and correction of your personal data held by EDB.  Request for access or correction of personal data should be made in writing to intake officer at Room 602, 6/F, 14 Taikoo Wan Road, Taikoo Shing, Hong Kong or email to <a href='mailto: jokc@edb.gov.hk'>jokc@edb.gov.hk</a>.",
        // p5: "如欲查詢有關本表格所蒐集的個人資料，包括要求查閱及改正資料事宜，需以書面方式向教育局提出。",
    },
    label: {
        header: "Important Notes",
        note: {
            // note: "Note:",
            note1: "The  information  you  provide  in  this  form  will  be  used  by  this Joint  Office for registration of your child care centre and may be disclosed to parties concerned on  a  need-to-know  basis.    The  name,  address  and  registration  date  of  your  child care centre and your name will be subject to inspection by the public in accordance with the provision stipulated in Section 8 of the Child Care Services Ordinance for the  purpose  of  verifying  that  your  child  care  centre  is  registered  under  the  above Ordinance.",
        },
        statement:
            "I have read, understood and agreed to the above terms and conditions.",
        iamStatement:
            "I understand applicant and the approving authority of the school need to have an “iAM Smart+” account to process the application.",
        titleOption: {
            Mr: "Mr.",
            Mrs: "Mrs.",
            Miss: "Miss",
            Ms: "Ms.",
        },
        qualificationOption: {
            P: "Primary",
            S: "Secondary",
            postSecondary: "Post-Secondary",
            T: "University",
            others: "Others",
        },
        childCareTrainingOption: {
            yes: "Yes, Please specify",
            no: "No",
        },
        childCareExperienceOption: {
            yes: "Yes, please specify",
            no: "No",
        },
        ownershipOfChildCareCentreOption: {
            yes: "Yes, please specify",
            no: "No",
        },
        personalInfo: "Personal Info",
        workExperience: "Work Experience",
        confirmation: "confirmation",
        nomineeTitle: "Title",
        // personalInfo: "PersonalInfo",
        // workExperience: "WorkExperience",
        // confirmation: "Confirmation",
        title: "Title",
        englishName: "English Name",
        chineseName: "Chinese Name",
        choose: "H.K.I.C. No./Passport No.",
        chooseOption: {
            hkid: "H.K.I.C. No.",
            passport: "Passport No.",
        },
        dateOfBirth: "Date of Birth",
        // year: "year",
        // mon: "month",
        // day: "day",
        nationality: "Nationality",
        residentialAddress: "Residential Address",
        specify: "Please specify:",
        tel: "Tel. No.",
        fax: "Fax No.",
        sameAsAddress: "Correspondence information is same as above",
        yes: "Yes",
        no: "No",
        conditionsCheck: "",
        correspondenceAddress: "Correspondence Address",
        tel1: "Tel. No.",
        fax1: "Fax No.",
        presentOccupation: "Present Occupation",
        qualification: "Qualification",
        required: "mandatory fields",
        // 第二頁的title
        childCareTraining: "Child Care Training",
        nameOfInstitute: "Name of Institute",
        courseName: "Course Name (as printed on Certificate)",
        yearOfAward: "Year of Award",
        childCareExperience:
            " Child Care Experience (please include present employment)",
        nameOfChildCareCentre: "Name of Child Care Centre/Agency",
        position: "Post Held",
        dateOfCommencement: "Date of Commencement",
        leaving: "Have you left the position",
        leavingOption: {
            yes: "Yes",
            no: "No",
        },
        dateOfLeaving: "Date of Leaving",
        ageRangeOfChildrenServed: "Age Range of Children Served",
        jianhao: "-",
        ageRangeOfChildrenServed2: "",
        ownershipOfChildCareCentre: "Ownership of Child Care Centre",
        nameOfCentre: "Name of Centre",
        periodOfOwnership: "Period of Ownership",
        nautreOfOwnership: "Nature of Ownership",
        nautreOfOwnershipOption: {
            sole: "Sole",
            shared: "Shared",
        },
        year: "e.g. “2-3” for 2-3 years",
    },
    errorMsg: {
        chineseName: "Please input a valid Chinese name",
        englishName: "Please input a valid English name",
        passport: "Please input a valid Passport No.",
        nationality: "Please input a valid Nationality",
        instituteName: "Please input a valid name of institute",
        courseName: "Please input a valid course name",
        childCareCentre:
            "Please input a valid name of child care centre/agency",
        centreName: "Please input a valid name of centre",
        ownership: "Please input a valid period of ownership",
        range: "Please input a valid range (e.g.“2-3”)",
        residentialAddress: "Please input a valid residential address",
        correspondenceAddress: "Please input a valid correspondence address",
        presentOccupation: "Please input a valid present occupation",
        otherQualification: "Please input a valid qualification",
        position: "Please input a valid position",
        tel: "Please input at least one telephone number.",
        E001: "Numbers are not allowed",
        E002: "match be alphabets ",
        E003: "alpha-numeric or Chinese-numeric",
        E004: "match hkic rules(default: XX999999(X))",
        E005: "match passport rules(Maximum length default 10, Character type alpha-numeric)",
        E006: "match be numbers",
        code: "Please input a valid area code",
    },
};
export default Form047EN;
